import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { createConsumer } from '../../context';
import Input from '../../components/Input';
import Button from '../../components/Button';

import styles from './index.scss';

class Forgot extends Component {
  state = {
    disabled: false,
  };

  usernameRef = React.createRef();

  componentDidMount() {
    this.handleOnChange();
  }

  handleOnChange = () => {
    const username = this.usernameRef.current.ref.current.value;

    if (
      username &&
      username !== '' &&
      username.length > 3
    ) {
      this.setState({
        error: null,
        success: null,
        disabled: false,
      });
    } else {
      this.setState({
        error: null,
        success: null,
        disabled: true,
      });
    }
  }

  handleForgot = async () => {
    const { forgotPassword } = this.props;
    this.setState({ error: null });
    const username = this.usernameRef.current.ref.current.value;
    if (username && username !== '') {

      const error = await forgotPassword({
        username,
      });

      if (error) {
        this.setState({ error });
        return null;
      }
    }

    this.setState({
      success: {
        message: 'Моля проверете вашият Е-мейл',
      }
    });
  }

  render() {
    const { success, error, disabled } = this.state;

    return (
      <div className={styles.loginWrapper}>
        <img src="/images/logo.png" height="40" alt="" />
        <h5>Забравена Парола</h5>
        <div className="box">
          <div className={styles.loginHolder}>
            <div className={styles.login}>
              <div className="form-group">
                <Input
                  type="text"
                  name="username"
                  label="Е-мейл адрес"
                  width={240}
                  placeholder="Вашият Е-мейл"
                  ref={this.usernameRef}
                  onChange={this.handleOnChange}
                />
              </div>

              {
                error && <div className="invalid">{error.message}</div>
              }

              {
                success && <div className="success">{success.message}</div>
              }

              <Button
                color="blue"
                width={240}
                disabled={disabled}
                value='Изпрати'
                onClick={this.handleForgot}
              />
            </div>

            <div className={styles.footer}>
              <p>Имаш акаунт? <Link to="/login">Влез</Link></p>
              <p>Все още нямаш акаунт? <Link to="/register">Създай Сега</Link></p>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

const mapContextToProps = ({ action }) => ({
  forgotPassword: action.forgotPassword
});

export default createConsumer(mapContextToProps)(Forgot);
